import Cookies from 'js-cookie';
import { DEFAULT_REGION_ID } from '../../globalConsts';

export const getRegionId = () =>
  window?.BX?.City?.ID ||
  Cookies.get('regionId') ||
  DEFAULT_REGION_ID;
